module.exports = __webpack_public_path__ + "static/img/43-2.3ab3576.png";